/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import { useEffect, useMemo, type JSX } from 'react'
import { Matrix4, Mesh } from 'three'
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

import { useColorMapGLTF } from '@hooks'

interface GLTFResultNodes {
  ['train-carriage-flatbed_1']: Mesh
  ['wheels-front']: Mesh
  ['wheels-back']: Mesh
}

type WagonFlatModelProps = JSX.IntrinsicElements['group'] & { highlight?: boolean }

export function WagonFlatModel(props: WagonFlatModelProps) {
  const { nodes, material } = useColorMapGLTF<GLTFResultNodes>(
    '/models/train/train-carriage-flatbed.glb',
    'train',
  )

  const mergedGeometry = useMemo(() => {
    return mergeGeometries([
      nodes['train-carriage-flatbed_1'].geometry,
      nodes['wheels-front'].geometry
        .clone()
        .applyMatrix4(new Matrix4().makeTranslation(0, 0.359, 0.6)),
      nodes['wheels-back'].geometry
        .clone()
        .applyMatrix4(new Matrix4().makeTranslation(0, 0.359, -0.6)),
    ])
  }, [nodes])

  useEffect(() => {
    return () => {
      mergedGeometry?.dispose()
    }
  }, [mergedGeometry])

  return (
    <group {...props}>
      <mesh castShadow receiveShadow geometry={mergedGeometry} material={material} />
    </group>
  )
}

useGLTF.preload('/models/train/train-carriage-flatbed.glb')
